import { useEffect, useState } from "react";
import api from "../lib/api";
import { Newspaper } from "@phosphor-icons/react";

export default function ReportersAdmin() {
  const [roster, setRoster] = useState({ reporters: [], non_reporters: [] });
  const [q, setQ] = useState("");

  const load = async (query = "") => {
    try {
      const { data } = await api.get(`/admin/reporter-roster${query ? `?q=${encodeURIComponent(query)}` : ""}`);
      setRoster(data);
    } catch (e) { console.error("reporter roster failed", e); }
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (userId, name, makeReporter) => {
    const verb = makeReporter ? "Grant" : "Revoke";
    if (!window.confirm(`${verb} Reporter status for ${name || userId}?`)) return;
    try {
      await api.post(`/admin/users/${userId}/reporter`, { is_reporter: makeReporter });
      load(q);
    } catch (e) { console.error("set reporter failed", e); }
  };

  return (
    <div data-testid="reporter-roster" className="card-sharp p-4 sm:p-5 border-[#D4AF37]/30">
      <div className="flex items-center justify-between gap-2 flex-wrap mb-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-neon-pink flex items-center gap-2">
            <Newspaper size={12} weight="fill"/> Reporter roster
          </div>
          <div className="text-[11px] text-muted-foreground mt-1">
            Reporters can publish News posts and edit the Breaking Bar.
          </div>
        </div>
        <input
          data-testid="reporter-roster-search"
          value={q}
          onChange={(e) => { setQ(e.target.value); load(e.target.value); }}
          placeholder="Search members…"
          className="input-sharp w-full sm:w-64"
        />
      </div>

      <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-1.5">
        Current reporters · {roster.reporters.length}
      </div>
      {roster.reporters.length === 0 && (
        <div className="text-[11px] text-muted-foreground italic mb-3">No reporters yet — promote anyone below.</div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        {roster.reporters.map((u) => (
          <div key={u.user_id} data-testid={`reporter-row-${u.user_id}`} className="flex items-center justify-between gap-2 border border-[#D4AF37]/30 p-2.5">
            <div className="min-w-0 flex-1">
              <div className="text-sm truncate">{u.name}</div>
              <div className="text-[10px] text-muted-foreground truncate">
                {u.username ? `@${u.username} · ` : ""}{u.email}
              </div>
            </div>
            <button
              data-testid={`reporter-revoke-${u.user_id}`}
              onClick={() => setStatus(u.user_id, u.name, false)}
              className="text-[10px] uppercase tracking-widest border border-white/15 text-muted-foreground hover:border-[#D4AF37] hover:text-[#D4AF37] px-2 py-1"
            >Revoke</button>
          </div>
        ))}
      </div>

      <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-1.5">
        Promote a member · top {roster.non_reporters.length}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {roster.non_reporters.map((u) => (
          <div key={u.user_id} data-testid={`reporter-member-${u.user_id}`} className="flex items-center justify-between gap-2 border border-white/10 p-2.5">
            <div className="min-w-0 flex-1">
              <div className="text-sm truncate">{u.name}</div>
              <div className="text-[10px] text-muted-foreground truncate">
                {u.username ? `@${u.username} · ` : ""}{u.email}
              </div>
            </div>
            <button
              data-testid={`reporter-grant-${u.user_id}`}
              onClick={() => setStatus(u.user_id, u.name, true)}
              className="text-[10px] uppercase tracking-widest border border-[#D4AF37]/40 text-neon-pink hover:bg-[#D4AF37]/10 px-2 py-1"
            >Grant reporter</button>
          </div>
        ))}
        {roster.non_reporters.length === 0 && (
          <div className="text-[11px] text-muted-foreground italic">No matches.</div>
        )}
      </div>
    </div>
  );
}
